import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { FormInputProps } from "./FormInputProps";

export const FormMultilineInputText = ({ name, control, label, required = false, minRows = 4 }: FormInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required ? `${label} is required` : false }}  // Use the required prop
      render={({
        field: { onChange, value },
        fieldState: { error },
      }) => (
        <TextField
          //helperText={error ? error.message : null}
          size="small"
          error={!!error}
          onChange={onChange}
          className="mb-3"
          value={value}
          fullWidth
          label={label}
          variant="outlined"
          multiline
          minRows={minRows}
        />
      )}
    />
  );
};
